import React, { useState } from "react";

import { setPopupEnabled } from "../../slices/actions";
import { useDispatch, useSelector } from "../../utils/hooks";
import strings from "../../utils/strings";

export const Configuration = () => {
	const dispatch = useDispatch();
	const isPopupEnabled = useSelector(
		(state) => state.popup.configuration.isPopupEnabled,
	);

	const canCustomerDisablePopup = useSelector(
		(state) => state.popup.canCustomerDisablePopup,
	);

	const [isChecked, toggleIsChecked] = useState(isPopupEnabled);

	return (
		<section className="addtocart-popup__configuration">
			<form className="responsive-form">
				{canCustomerDisablePopup && (
					<div className="checkbox-set">
						<div className="input">
							<input
								type="checkbox"
								id="enablePopupCheckbox"
								checked={isChecked}
								onChange={({ target: { checked } }) => {
									toggleIsChecked(!isChecked);
									dispatch(setPopupEnabled(checked));
								}}
							/>
							<label htmlFor="enablePopupCheckbox">
								{strings.enableaddtocartpopup}
							</label>
						</div>
					</div>
				)}
			</form>
		</section>
	);
};

